import { render, staticRenderFns } from "./TravelSearchBarComponent.vue?vue&type=template&id=45e3b679"
import script from "./TravelSearchBarComponent.vue?vue&type=script&lang=js"
export * from "./TravelSearchBarComponent.vue?vue&type=script&lang=js"
import style0 from "./TravelSearchBarComponent.vue?vue&type=style&index=0&id=45e3b679&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports